
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.833 6.267a.866.866 0 01-.791-.507l-1.39-2.965H8.494L7.104 5.76a.867.867 0 01-.792.507H4.3L2.944 9.802a.9.9 0 01-.777.632h-.5v1.042h.5c.124-.002.247-.019.368-.049v5.778h1.041v-1.778c.269.139.566.213.868.215h6.945c.302-.002.6-.076.868-.215v1.778h1.042v-5.778c.12.03.244.047.368.049h1.889c.302-.003.6-.077.868-.216v1.778h1.041v-5.77c.121.027.244.041.368.041h.5V6.267h-.5zm-9.764-.07l1.09-2.36h5.848l1.09 2.36.042.07H8.028l.041-.07zM5.014 7.31h5.805l1.098 2.868c.034.089.076.175.125.257h-8.25c.048-.082.09-.168.125-.257L5.014 7.31zm6.375 7.292H4.444a.868.868 0 01-.868-.868v-2.257h8.68v2.257c0 .48-.388.868-.867.868zm4.167-4.167h-1.89a.901.901 0 01-.777-.632L11.93 7.31h4.493v2.257c0 .48-.389.868-.868.868zm-1.39-2.083h1.39v1.041h-1.39V8.351zM10 12.517h1.389v1.042H10v-1.042zm-5.556 0h1.39v1.042h-1.39v-1.042z","fill":"#05B5E4","fill-rule":"evenodd"}})])
          )
        }
      }
    